/* ZeroNic, interactions & motion (ported from the Netlify design source) */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) {
    return (c || document).querySelector(s);
  }
  function $all(s, c) {
    return Array.prototype.slice.call((c || document).querySelectorAll(s));
  }

  /* ---------- announcement bar dismiss ---------- */
  function announce() {
    var bar = $('#announce');
    var close = $('[data-announce-close]');
    if (!bar || !close) return;
    if (sessionStorage.getItem('zeronic_announce_closed') === '1') {
      bar.style.display = 'none';
    }
    close.addEventListener('click', function () {
      bar.style.height = bar.offsetHeight + 'px';
      requestAnimationFrame(function () {
        bar.style.transition = 'height .3s ease, opacity .3s ease';
        bar.style.height = '0';
        bar.style.opacity = '0';
        bar.style.overflow = 'hidden';
      });
      setTimeout(function () {
        bar.style.display = 'none';
      }, 320);
      sessionStorage.setItem('zeronic_announce_closed', '1');
    });
  }


  /* ---------- rotating announcement messages ---------- */
  function announceRotator() {
    var wrap = $('[data-announce-rotator]');
    if (!wrap) return;
    var msgs = $all('[data-announce-msg]', wrap);
    if (msgs.length < 2) return;
    if (prefersReduced) return;

    var interval = (parseFloat(wrap.getAttribute('data-interval')) || 5) * 1000;
    var i = 0;

    // Stack them so they cross-fade in place rather than reflowing the bar.
    var h = msgs[0].offsetHeight;
    msgs.forEach(function (m, n) {
      m.style.position = 'absolute';
      m.style.inset = '0';
      m.style.display = 'flex';
      m.style.opacity = n === 0 ? '1' : '0';
    });
    wrap.style.position = 'relative';
    if (h) wrap.style.height = h + 'px';

    setInterval(function () {
      if (document.hidden) return;
      msgs[i].style.opacity = '0';
      i = (i + 1) % msgs.length;
      msgs[i].style.opacity = '1';
    }, interval);
  }

  /* ---------- sticky nav state on scroll ---------- */
  function navState() {
    var header = $('#nav');
    if (!header) return;
    var nav = $('nav', header);
    function onScroll() {
      var scrolled = window.scrollY > 24;
      if (nav) {
        nav.classList.toggle('shadow-lift', scrolled);
        nav.classList.toggle('!bg-cream/95', scrolled);
      }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile nav (added, the source design had no mobile menu) ---------- */
  function mobileNav() {
    var toggle = $('[data-nav-toggle]');
    var panel = $('[data-nav-panel]');
    if (!toggle || !panel) return;

    var iconOpen = $('[data-nav-icon-open]', toggle);
    var iconClose = $('[data-nav-icon-close]', toggle);
    var open = false;

    // Start from the collapsed visual state without a transition on first paint.
    panel.hidden = true;
    panel.style.opacity = '0';
    panel.style.transform = 'scaleY(0.96)';

    function setOpen(next) {
      open = next;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (iconOpen) iconOpen.classList.toggle('hidden', open);
      if (iconClose) iconClose.classList.toggle('hidden', !open);

      if (open) {
        panel.hidden = false;
        requestAnimationFrame(function () {
          panel.style.opacity = '1';
          panel.style.transform = 'scaleY(1)';
        });
      } else {
        panel.style.opacity = '0';
        panel.style.transform = 'scaleY(0.96)';
        if (prefersReduced) {
          panel.hidden = true;
        } else {
          setTimeout(function () {
            if (!open) panel.hidden = true;
          }, 300);
        }
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(!open);
    });

    // Close when a link is chosen (same-page anchors would otherwise leave it open).
    $all('a', panel).forEach(function (a) {
      a.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) {
        setOpen(false);
        toggle.focus();
      }
    });

    // Clicking outside the header closes it.
    document.addEventListener('click', function (e) {
      if (!open) return;
      var header = $('#nav');
      if (header && !header.contains(e.target)) setOpen(false);
    });

    // Leaving mobile width resets state so the desktop nav is never left hidden.
    var mq = window.matchMedia('(min-width: 1024px)');
    var onChange = function (e) {
      if (e.matches && open) setOpen(false);
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
  }

  /* ---------- rotating hero chips ---------- */
  function heroChips() {
    var wrap = $('[data-hero-chips]');
    if (!wrap) return;
    var chips = $all('[data-hero-chip]', wrap);
    if (chips.length < 2) return;

    // Auto-rotating content is motion; hold on the first chip if that is unwelcome.
    if (prefersReduced) return;

    var interval = (parseFloat(wrap.getAttribute('data-interval')) || 4) * 1000;
    var index = 0;

    // Stack every chip at the same anchor so they cross-fade in place. The first
    // one is left in flow by Liquid to give the wrapper its height; take it out
    // now that we know we are rotating.
    chips.forEach(function (chip, i) {
      chip.style.position = 'absolute';
      chip.style.left = '0';
      chip.style.bottom = '0';
      chip.style.opacity = i === 0 ? '1' : '0';
    });
    wrap.style.height = chips[0].offsetHeight + 'px';
    wrap.style.width = '1px';

    setInterval(function () {
      if (document.hidden) return;
      chips[index].style.opacity = '0';
      index = (index + 1) % chips.length;
      chips[index].style.opacity = '1';
    }, interval);
  }

  /* ---------- scroll reveal ---------- */
  function reveal() {
    var els = $all('.reveal');
    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- parallax ---------- */
  function parallax() {
    var els = $all('[data-parallax]');
    if (prefersReduced || !els.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var speed = parseFloat(el.getAttribute('data-parallax-speed')) || 0.1;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        var shift = -progress * speed * 100;
        el.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0)';
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* ---------- count-up ---------- */
  function countup() {
    var els = $all('[data-countup]');
    if (!els.length) return;
    function run(el) {
      var to = parseFloat(el.getAttribute('data-to')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      if (prefersReduced) {
        el.textContent = to.toLocaleString('en-US') + suffix;
        return;
      }
      var dur = 1400;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * eased).toLocaleString('en-US') + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) {
      els.forEach(run);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            run(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- graceful image fallback ---------- */
  function imageFallback() {
    function fallback(img) {
      if (img.dataset.fellBack) return;
      img.dataset.fellBack = '1';
      var label = (img.getAttribute('alt') || 'ZeroNic').trim() || 'ZeroNic';
      var holder = document.createElement('div');
      holder.className =
        'flex h-full w-full items-center justify-center bg-gradient-to-br from-sand-light via-sand to-terracotta/40 p-4 text-center';
      holder.innerHTML =
        '<span class="font-display text-sm font-medium text-ink/55"></span>';
      holder.firstChild.textContent = label;
      if (img.parentNode) img.parentNode.replaceChild(holder, img);
    }
    $all('img').forEach(function (img) {
      if (img.complete && img.naturalWidth === 0) {
        fallback(img);
      } else {
        img.addEventListener('error', function () {
          fallback(img);
        });
      }
    });
  }

  /* Review wall: reveal the next batch of cards in place. The grid is a CSS
     multi-column masonry, so un-hiding cards is all that's needed, the columns
     re-flow on their own. */
  function reviewMore() {
    $all('[data-review-more]').forEach(function (btn) {
      var section = btn.closest('section');
      var grid = section ? $('[data-review-grid]', section) : null;
      if (!grid) return;

      var step = parseInt(btn.getAttribute('data-step'), 10) || 12;

      btn.addEventListener('click', function () {
        var hidden = $all('[data-review-card].hidden', grid);
        hidden.slice(0, step).forEach(function (card) {
          card.classList.remove('hidden');
        });

        if (hidden.length <= step) {
          btn.disabled = true;
          btn.classList.add('pointer-events-none', 'opacity-50');
          var done = btn.getAttribute('data-label-done');
          if (done) btn.textContent = done;
        }

        // Keep the focus ring on something visible after the button retires.
        var revealed = hidden[0];
        if (revealed) revealed.setAttribute('tabindex', '-1');
      });
    });
  }

  function init() {
    announce();
    announceRotator();
    navState();
    mobileNav();
    heroChips();
    reveal();
    parallax();
    countup();
    reviewMore();
    imageFallback();
    $all('[data-year]').forEach(function (el) {
      el.textContent = new Date().getFullYear();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
